import { Grid, GridColumn } from '@progress/kendo-react-grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'
import * as App from '../../app/types'
import { FlashMessage } from '../../components/flash-message'
import { Loading } from '../../components/loading'
import * as Render from './render'
import * as Types from './types'

import './styles.css'

const IntegrationMappingsHeader = () =>
<div>
  <FlashMessage />
  <Row className="margin-auto">
    <Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Integration Mappings</span>
      </div>
    </Col>
  </Row>
</div>

const MappingsTable = ({integrationMappings}: any) => {
  let systemName
  const actions = integrationMappings.data.actions
  const subscribers = integrationMappings.data.subscribers
  const topics = integrationMappings.data.topics

  if (subscribers.length > 0) {
    systemName = subscribers[0].system_name
  }
  return integrationMappings.view.isFetching ?
    <span>
      <Loading size={Loading.Sizes.MEDIUM}/>
    </span>
    :
    <div className="existing-mappings-container">
      {!!subscribers.length &&
      <div className="subscribers-mappings-container">
        <p>Rasa's
          <b> {subscribers[0].sync_type_name} </b>
          currently mapped to {systemName}'s
          <b> {subscribers[0].target_object}s</b>
        </p>
        <Grid data={integrationMappings.data.subscribers}
              resizable={true}>
          <GridColumn field="rasa_field_name" title="Rasa field" width={200}/>
          <GridColumn field="target_field_name" title={systemName + ' field'} width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_rasa" title="Update in Rasa" width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_target" title={'Update in ' + systemName} width={200}/>
        </Grid>
      </div>}
      {!!actions.length &&
      <div className="actions-mappings-container">
        <p>Rasa's
          <b> {actions[0].sync_type_name} </b>
          currently mapped to {systemName}'s
          <b> {actions[0].target_object}s</b>
        </p>
        <Grid data={integrationMappings.data.actions}
              resizable={true}>
          <GridColumn field="sync_type_name" title="Rasa object" width={200}/>
          <GridColumn field="target_object" title={systemName + ' object'} width={200}/>
          <GridColumn field="rasa_field_name" title="Rasa field" width={200}/>
          <GridColumn field="target_field_name" title={systemName + ' field'} width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_rasa" title="Update in Rasa" width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_target" title={'Update in ' + systemName} width={200}/>
        </Grid>
      </div>}
      {!!topics.length &&
      <div className="topics-mappings-container">
        <Grid data={integrationMappings.data.topics}
              resizable={true}>
          <GridColumn field="sync_type_name" title="Rasa object" width={200}/>
          <GridColumn field="target_object" title={systemName + ' object'} width={200}/>
          <GridColumn field="rasa_field_name" title="Rasa field" width={200}/>
          <GridColumn field="target_field_name" title={systemName + ' field'} width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_rasa" title="Update in Rasa" width={200}/>
          <GridColumn cell={Render.StatusCell} field="update_in_target" title={'Update in ' + systemName} width={200}/>
        </Grid>
      </div>}
    </div>
}

const MappingsTableTableConnected = connect(
  ({integrationMappings, app}: Types.WrappedState & App.WrappedState) => ({integrationMappings, app}),
)(MappingsTable)

export const IntegrationsMappings = ({ integrationMappings}: any) =>
<div>
  <IntegrationMappingsHeader/>
  <MappingsTableTableConnected/>
</div>



// WEBPACK FOOTER //
// ./src/pages/integration-mappings/component.tsx